/**
 * Calendar List
 */

const calendarList = {
    cfg: {
        cell: '.js-tableCell'
    },

    init() {
        window.addEventListener('load', () => {
            const cells = [...document.querySelectorAll(this.cfg.cell)];

            if (cells) {
                cells.forEach((cell) => {
                    const backgroundImages = cell.querySelectorAll('.o-calendarList__backgroundImage');
                    const privateImages = cell.querySelectorAll('.o-calendarList__backgroundImage--private');

                    if (backgroundImages.length > 1 && backgroundImages > privateImages) {
                        backgroundImages.forEach((backgroundImage) => {
                            // eslint-disable-next-line
                            if (backgroundImage.classList.contains('o-calendarList__backgroundImage--private')) {
                                backgroundImage.style.display = 'none';
                            }
                        });
                    }
                });
            }
        });
    }
};

export default calendarList;



// WEBPACK FOOTER //
// ./___src/templates/_organisms/calendarList/_script.js